import { Box, Divider, TextField, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { ChangeEvent, useState } from "react";
import CloseIcon from "../../../../../../../../assets/images/icons/CloseIcon";
import SolidGradientColorPicker from "../../../../../../../../components/common/SolidGradientColorPicker/SolidGradientColorPicker";
import { useCustomColorPicker } from "../../../../../../../../hooks/useCustomColotPicker";
import { useAppStore } from "../../../../../../../../hooks/useStores";
import { Property } from "../../../../../../../CustomUtils/UseDesignEditor";
import SelectedBrandColors from "../../../../Panels/panelItems/Common/SelectedBrandColors/SelectedBrandColors";
import styles from "./ColorBoxPicker.module.scss";
interface Props {
	color?: string;
	onColorChange?: (color: string, brandColor?: boolean) => void;
	disabled?: boolean;
	withPadding?: boolean;
	title?: string;
	showSelectedBrandColors?: boolean;
	activeObject: any;
}

function ColorBoxPicker({
	color,
	onColorChange,
	disabled,
	withPadding = true,
	title,
	showSelectedBrandColors = false,
	activeObject,
}: Props) {
	const DEFAULT_COLOR = "#FFFFFF";
	const PLACEHOLDER_COLOR = "#8800FF";
	const { colorToHex } = useCustomColorPicker();
	const [showPicker, setShowPicker] = useState(false);
	const { campaignStore } = useAppStore();
	const handleIconClick = () => {
		setShowPicker(!showPicker);
	};

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const {
			target: { value: color },
		} = e;
		onColorChange?.(color);
	};

	return (
		<Box className={styles.container}>
			<Box
				style={{
					backgroundColor: color,
					background: color,
				}}
				onClick={handleIconClick}
				className={styles.colorBox}
			>
				{showPicker && (
					<Box className={styles.colorPickerContainer}>
						<Box
							className={clsx({
								[styles.colorPicker]: true,
								[styles.staticPosition]: true,
							})}
						>
							{title && <Typography className={styles.title}>{title}</Typography>}
							<CloseIcon onClick={() => {}} className={styles.closeIcon} />
							<SolidGradientColorPicker
								color={color ?? DEFAULT_COLOR}
								onChange={(color: string) => {
									const hexColor = colorToHex(color);
									if (hexColor) {
										onColorChange?.(hexColor);
									}
								}}
								hideColorTypeBtns={true}
							/>
							{showSelectedBrandColors && (
								<>
									{campaignStore.selectedTemplate?.is_branded_template && (
										<Divider className={styles.mainDivider} />
									)}
									<SelectedBrandColors
										activeObject={activeObject}
										updateColor={(color: string) => {
											onColorChange?.(color, true);
										}}
										property={Property.SHADOW_COLOR_NUMBER}
									/>
								</>
							)}
						</Box>
					</Box>
				)}
			</Box>
			<TextField
				placeholder={PLACEHOLDER_COLOR}
				fullWidth
				InputProps={{
					classes: {
						root: styles.textField,
					},
				}}
				className={clsx({
					[styles.colorTextfield]: withPadding,
				})}
				value={color}
				onChange={handleChange}
				disabled={disabled}
			/>
		</Box>
	);
}

const ObservedComponent = observer(ColorBoxPicker);
export default ObservedComponent;
